import React from "react";

function ErrorPage({error}) {
    const message =
        error?.response?.data?.message ||
        error?.message ||
        (typeof error === "string" ? error : "خطایی رخ داد!");
    return <div>Error: {message}</div>
}

export default ErrorPage;